import Address from '@/models/Customers/Addresses/Address';
import Association from "@/models/Customers/Associations/Association";

export default class Organisation {
    id: string = '';
	name: string = '';
	registrationNumber: string = '';
	registrationCountry: string = '';
	associations: Association[] = [];
	addresses: Address[] = [];
	metadata: JSON;
	createdAt: Date = new Date();
	updatedAt: Date = new Date();
}
